import { ArrayValue, RecordValue, Schema, StringValue } from '@coveo/bueno';
import { facetResultsMustMatch, } from '../../../../features/facets/facet-api/request.js';
import { facetSortCriteria, } from '../../../../features/facets/facet-set/interfaces/request.js';
import { facetId, facetSearch, field, filterFacetCount, injectionDepth, numberOfValues, } from '../_common/facet-option-definitions.js';
export const facetOptionsSchema = new Schema({
    facetId,
    tabs: new RecordValue({
        options: {
            required: false,
        },
        values: {
            included: new ArrayValue({ each: new StringValue() }),
            excluded: new ArrayValue({ each: new StringValue() }),
        },
    }),
    field,
    filterFacetCount,
    injectionDepth,
    numberOfValues,
    sortCriteria: new StringValue({ constrainTo: facetSortCriteria }),
    resultsMustMatch: new StringValue({ constrainTo: facetResultsMustMatch }),
    facetSearch,
});
